import { strict } from 'assert';
import locales from './locales';

const values = JSON.parse(process.env.REACT_APP_LOCALES_NAME);

if (process.env.NODE_ENV === 'development') {
  strict.equal(values.length, locales.length, 'Each locale has name');
}

const getName = (locale) => values[locales.indexOf(locale)];

export default getName;
